import styles from './QuickMenu.module.css';
import imgConsent from '../../../../assets/images/event/consent-68x69.png'
import imgKakaotalk from '../../../../assets/images/event/kakaotalk-68x69.png'
import imgPhone from '../../../../assets/images/event/phone-68x69.png';

const KAKAO_URL = "https://open.kakao.com/o/gYn9pUui";

function QuickMenu({ onConsentClick }) {
  return (
    <div className={styles.quickMenu}>
      <nav>
        <ul>
          <li><a href={KAKAO_URL} target="_blank" rel="noopener noreferrer"><img src={imgKakaotalk} /></a></li>
          <li><a href="tel:15333940"><img src={imgPhone} /></a></li>
          <li><a href="#" onClick={onConsentClick}><img src={imgConsent} /></a></li>
        </ul>
      </nav>
    </div>
  );
}

 export default QuickMenu;